var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blackout"},[_c('div',{staticClass:"popup popup-game"},[_c('game')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }